import { RaffleStatus } from '@/types/enums';

export const isRaffleOnSale = (status?: string): boolean =>
  status === RaffleStatus.Enum.IN_PROGRESS;

export const isRaffleUpcoming = (status?: string): boolean =>
  status === RaffleStatus.Enum.NOT_STARTED;

export const UPCOMING_SALE_LABEL = 'Em Breve';
export const UPCOMING_SALE_BADGE_TEXT = 'vendas em breve';

export const getRaffleCtaLabel = (
  status: string | undefined,
  onSaleLabel: string,
): string => {
  if (isRaffleOnSale(status)) return onSaleLabel;
  if (isRaffleUpcoming(status)) return UPCOMING_SALE_LABEL;

  return 'Finalizado';
};
